module.exports = __webpack_public_path__ + "static/media/mail.9cd6ad8f.svg";